import { model as i18n } from '!/i18n'
import { combine, type Store } from 'effector'
import { model as config, remote } from '@/config'

export const $guestRegistrationLink: Store<string> = config.get(
  remote.tria_guestRegistrationLink
)

export const $signInToWatchTranslations = combine(i18n.$t, ({ t }) => ({
  signIn: t('sign_in'),
  cancel: t('cancel'),
  signInToWatch: t('sign_in_to_watch'),
}))
